<template>
    <div class="main Ssdt">
        <Titledx text='智慧网格案件诉求实时动态' />
        <div class="cont">
            <div class="title">
                <span class="source">上报人</span>
                <span class="eventTitle">案件详情</span>
                <span class="time">上报时间</span>
                <span class="time">下派时间</span>
                <span class="department">处置部门</span>
                <span class="status">办理状态</span>
            </div>
            <div class="info">
                <swiper
                    :options="swiperOption"
                    ref="infoSwiper"
                    style="width: 100%; height: 100%"
                    v-if="ifShowSwiper"
                >
                    <swiper-slide
                        v-for="(item, i) in list"
                        :key="i"
                        style="height: 100px"
                    >
                        <div
                            class="box"
                            :style="{ color: item.color ? item.color : '' }"
                        >
                            <span class="source">{{ item.createuser }}</span>
                            <span class="eventTitle">{{
                                item.content
                            }}</span>
                            <span class="time">{{ item.createtime }}</span>
                            <span class="time">{{ item.starttime }}</span>
                            <span class="department">{{
                                item.orgname
                            }}</span>
                            <span :class="['status',item.state=='办理中'?'doing':'done',]">{{ item.state }}</span>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>
</template>
<script>
import Titledx from "./components/title";
import miment from "miment";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
    components: {
        swiper,
        swiperSlide,
        Titledx,
    },
    data() {
        return {
            ifShowSwiper: false,
            swiperOption: {
                autoplay: {
                    delay: 3000,
                },
                direction: "vertical",
                speed: 3000,
                slidesPerView: 12,
                slidesPerGroup: 1,
                loop: true,
            },
            list: [],
        };
    },
    methods: {

        async getData() {
            let res = await this.$get(this.urlobj.dx_ssdt)
            this.list = res
            this.ifShowSwiper = true;
 
        }

        
    },
    created() {
        this.getData()
    },
    mounted() {
        // document.getElementsByClassName("Ssdt")[0].style.zoom = 0.5;
        // let huanjing = window.location.href.split("//")[1].split("/")[0];
        // console.log(huanjing);
        // window.btnclick = function (type) {
        //     if (type == "goback") {
        //         if (huanjing == "ct.shequyun.cn") {
        //             window.open(
        //                 "https://ceshi.shequyun.cn/#/moduleList",
        //                 "_self"
        //             );
        //         } else {
        //             window.open(`https://${huanjing}/#/moduleList`, "_self");
        //         }
        //     }
        // };
    },
};
</script>
<style lang="less" scoped>
.main {
    overflow: hidden;
    .cont {
        height: 799px;
        margin-left: 20px;
        box-sizing: border-box;
        padding: 30px 40px;
        text-align: center;
        .source {
            width: 158px;
        }
        .eventTitle {
            width: 760px;
        }
        .time,
        .department,
        .status {
            width: 142px;
        }
        .source,
        .eventTitle,
        .time,
        .department,
        .status {
            margin: 0 20px 
        }
        .title {
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #18d0ff;
            width: 100%;
            background: rgba(29, 53, 97, 1);
            display: flex;
            align-items: center;
            justify-content: space-around;
            height: 64px;
            margin-bottom: 20px;
        }
        .info {
            .swiper-slide /deep/ {
                height: 48px !important;
                margin: 10px 0;
            }
            height: 810px;
            .box {
                width: 100%;
                height: 100%;
                color: #fff;
                font-size: 20px;
                background: rgba(29, 53, 97, 1);
                align-items: center;
                justify-content: space-around;
                span {
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .source{
                    font-size: 20px;
                }  
                .eventTitle {
                    font-size: 20px;
                    color: rgba(255, 217, 4, 1);
                }
                .time,
                .department,
                .status {
                    font-size: 16px;
                }
                .doing {
                    color:rgba(255, 168, 0, 1)
                }
                .done {
                    color:rgba(0, 255, 42, 1)
                }
                .source,
                .eventTitle,
                .time,
                .department,
                .status {
                    background: rgba(43, 71, 121, 1);
                    margin: 0 20px
                }
            }
        }
    }
}
</style>